import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Table } from 'react-bootstrap';
import { Row, Input, Radio } from 'antd';

import { MaterialSurfaceBillingUnit } from '../common/enums';
import { ProcessDetailGroups, handleKeyPress, regexExp, toDecimal } from '../common/Common';

const IQ3KouteiInput_Hyoumenshori = forwardRef((props, ref) => {
  const [hyoumenshoriValues, setHyoumenshoriValues] = useState([]);
  const [surfaceWorkType, setSurfaceWorkType] = useState([]);
  const [processDetailsType, setProcessDetailsType] = useState([]);

  useEffect(() => {
    if (props.type === '親部品' || props.isReCal) {
      const surfaceDetailsData = props?.kouteiInputInfo?.surfaceProcessInputInfo;
      setHyoumenshoriValues(surfaceDetailsData);
    } else {
      if (props?.tabOpen) {
        let data = props?.surfaceInfo;
        if (data != undefined) {
          setHyoumenshoriValues(data?.details);
        }
      }
    }
    setSurfaceWorkType(ProcessDetailGroups);
    const processDetailTypes = props?.surfaceData?.[0]?.details?.processDetailTypes || [];
    setProcessDetailsType(processDetailTypes);
  }, [props.hyoumenShoriVal, props.surfaceData, props.kouteiInputInfo, props.type, props?.isReCal]);

  useImperativeHandle(ref, () => ({
    setEditModeChange: setEditModeChange,
  }));

  const changeDetails = (event, id, types, calMethod) => {
    const temp = JSON.parse(JSON.stringify(hyoumenshoriValues));
    let updatedData;
    if (types === 'calcType') {
      if (calMethod === 'area') {
        updatedData = temp?.map((row) => {
          if (row.no === id) {
            return { ...row, [types]: MaterialSurfaceBillingUnit.SquareMeter };
          }
          return row;
        });
      } else if (calMethod === 'weight') {
        updatedData = temp?.map((row) => {
          if (row.no === id) {
            return { ...row, [types]: MaterialSurfaceBillingUnit.Weight };
          }
          return row;
        });
      }
    } else {
      updatedData = temp?.map((row) => {
        if (row.no === id) {
          const updatedRow = { ...row, [types]: !regexExp.test(event.target.value) ? event.target.value : 0 };
          if (types === 'areaUnitPrice' || types === 'areaCount') {
            // Calculate and update totalCount
            updatedRow.totalArea = toDecimal(toDecimal(updatedRow?.areaUnitPrice, 2) * updatedRow?.areaCount, 2);
          } else if (types === 'weightUnitPrice' || types === 'weightCount') {
            // Calculate and update totalCount
            updatedRow.totalWeight = toDecimal(toDecimal(updatedRow?.weightUnitPrice, 2) * updatedRow?.weightCount, 2);
          }

          return updatedRow;
        }
        return row;
      });
    }
    setHyoumenshoriValues(updatedData);
    if (props.type === '親部品') {
      props.updatedSurfaceProcessInput(updatedData);
    } else {
      const newSurfaceInfo = { ...props.surfaceInfo };
      newSurfaceInfo.details = updatedData;
      props.updateSurface(newSurfaceInfo);
    }
    props?.onDataChange(true); // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
  };

  const blurDetails = (event, id, types) => {
    const temp = JSON.parse(JSON.stringify(hyoumenshoriValues));
    let updatedData;

    updatedData = temp?.map((row) => {
      if (row.no === id) {
        const updatedRow = { ...row, [types]: toDecimal(event.target.value, 2) };

        return updatedRow;
      }
      return row;
    });

    setHyoumenshoriValues(updatedData);
    if (props.type === '親部品') {
      props.updatedSurfaceProcessInput(updatedData);
    } else {
      const newSurfaceInfo = { ...props.surfaceInfo };
      newSurfaceInfo.details = updatedData;
      props.updateSurface(newSurfaceInfo);
    }
    props?.onDataChange(true); // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
  };
  return (
    <>
      {props.type === '親部品' || (props?.tabOpen && props?.isHyoumenShori) ? (
        <Row className="mt-1 registerModal" align="middle">
          <Table className="kouteiinput" style={{ width: '87%' }}>
            <thead>
              <tr style={{ textAlign: 'center' }}>
                <th style={{ width: '1%' }} className="tbl-header">
                  No
                </th>
                <th style={{ width: '17.4%' }} className="tbl-header">
                  計算方法
                </th>
                <th style={{ width: '19.3%' }} colSpan={2} className="tbl-header">
                  詳細
                </th>
                <th style={{ width: '19.3%' }} className="tbl-header">
                  面積/重量
                </th>
                {/* <th style={{ width: '13%', display: 'none' }} className="tbl-header">
                自動抽出
              </th> */}
                <th style={{ width: '19.3%' }} className="tbl-header">
                  回数
                </th>
                <th style={{ width: '11%' }} className="tbl-header">
                  合計
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {hyoumenshoriValues?.map((i, index) => (
                <>
                  <tr key={index} style={{ verticalAlign: 'middle' }}>
                    <td rowSpan={2} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {index + 1}
                    </td>
                    <td style={{ verticalAlign: 'middle', textAlign: 'center', pointerEvents: 'none' }}>
                      <Radio
                        checked={
                          i.calcType === MaterialSurfaceBillingUnit.SquareMeter ||
                          i.calcType === MaterialSurfaceBillingUnit.Work
                        }
                      >
                        面積
                      </Radio>
                    </td>
                    <td rowSpan={2} style={{ verticalAlign: 'middle', width: '9.5%' }}>
                      <label>
                        {surfaceWorkType?.filter((item) => item.value === i.processDetailWorkTypeGroup)?.[0]?.label}
                      </label>
                    </td>

                    <td rowSpan={2} style={{ width: '9.5%' }}>
                      <label>
                        {processDetailsType?.filter((item) => item.id === i.processDetailTypeNo)?.[0]?.name}
                      </label>
                    </td>
                    <td>
                      <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>{i.areaAutoExtract}</label>
                      <Input
                        className="input-editable"
                        value={i.areaUnitPrice}
                        onChange={(e) => changeDetails(e, i.no, 'areaUnitPrice')}
                        onBlur={(e) => blurDetails(e, i.no, 'areaUnitPrice')}
                        style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                        onKeyPress={(e) => {
                          handleKeyPress(e, false);
                        }}
                      ></Input>
                    </td>
                    <td>
                      <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                        {i.areaCountAutoExtract}
                      </label>
                      <Input
                        className="input-editable"
                        value={i.areaCount}
                        onChange={(e) => changeDetails(e, i.no, 'areaCount')}
                        style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                        onKeyPress={(e) => {
                          handleKeyPress(e, false);
                        }}
                      ></Input>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <label style={{ marginRight: '5px' }}>{toDecimal(i.totalArea, 2)}</label>
                    </td>
                  </tr>
                  <tr style={{ verticalAlign: 'middle' }}>
                    <td style={{ verticalAlign: 'middle', textAlign: 'center', pointerEvents: 'none' }}>
                      <Radio checked={i.calcType === MaterialSurfaceBillingUnit.Weight}>重量</Radio>
                    </td>

                    <td>
                      <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                        {i.weightAutoExtract ? toDecimal(i.weightAutoExtract, 2) : toDecimal(0, 2)}
                      </label>
                      <Input
                        className="input-editable"
                        value={i.weightUnitPrice ? toDecimal(i.weightUnitPrice, 2) : toDecimal(0, 2)}
                        onChange={(e) => changeDetails(e, i.no, 'weightUnitPrice')}
                        onBlur={(e) => blurDetails(e, i.no, 'weightUnitPrice')}
                        style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                        onKeyPress={(e) => {
                          handleKeyPress(e, false);
                        }}
                      ></Input>
                    </td>
                    <td>
                      <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                        {i.weightCountAutoExtract}
                      </label>
                      <Input
                        className="input-editable"
                        value={i.weightCount}
                        onChange={(e) => changeDetails(e, i.no, 'weightCount')}
                        style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                        onKeyPress={(e) => {
                          handleKeyPress(e, false);
                        }}
                      ></Input>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <label style={{ marginRight: '5px' }}>{toDecimal(i.totalWeight, 2)}</label>
                    </td>
                  </tr>
                </>
              ))} */}
              {/* IQX_WEBEST-399 工程入力画面”表面処理”項目にて、計算方法で各表示の前に丸印があるが操作できない */}
              {hyoumenshoriValues?.map((i, index) => {
                const isArea =
                  i.calcType === MaterialSurfaceBillingUnit.SquareMeter ||
                  i.calcType === MaterialSurfaceBillingUnit.Work;
                const isWeight = i.calcType === MaterialSurfaceBillingUnit.Weight;

                return (
                  <>
                    {isArea && (
                      <tr key={`area-${index}`} style={{ verticalAlign: 'middle' }}>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                        <td style={{ verticalAlign: 'middle', textAlign: 'center', pointerEvents: 'none' }}>
                          <label>面積</label>
                        </td>
                        <td style={{ verticalAlign: 'middle', width: '9.5%' }}>
                          <label>
                            {surfaceWorkType?.find((item) => item.value === i.processDetailWorkTypeGroup)?.label}
                          </label>
                        </td>
                        <td style={{ width: '9.5%' }}>
                          <label>{processDetailsType?.find((item) => item.id === i.processDetailTypeNo)?.name}</label>
                        </td>
                        <td>
                          {/* 2025-06-27 IQX_WEBEST-429 子部品の工程入力の表記を変更してほしい */}
                          <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                            {i.areaAutoExtract && i.areaAutoExtract > 0 ? i.areaAutoExtract : '-'}
                          </label>
                          <Input
                            className="input-editable"
                            value={i.areaUnitPrice}
                            onChange={(e) => changeDetails(e, i.no, 'areaUnitPrice')}
                            onBlur={(e) => blurDetails(e, i.no, 'areaUnitPrice')}
                            style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                            onKeyPress={(e) => handleKeyPress(e, false)}
                          />
                        </td>
                        <td>
                          {/* 2025-06-27 IQX_WEBEST-429 子部品の工程入力の表記を変更してほしい */}
                          <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                            {i.areaCountAutoExtract && i.areaCountAutoExtract > 0 ? i.areaCountAutoExtract : '-'}
                          </label>
                          <Input
                            className="input-editable"
                            value={i.areaCount}
                            onChange={(e) => changeDetails(e, i.no, 'areaCount')}
                            style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                            onKeyPress={(e) => handleKeyPress(e, false)}
                          />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <label style={{ marginRight: '5px' }}>{toDecimal(i.totalArea, 2)}</label>
                        </td>
                      </tr>
                    )}

                    {isWeight && (
                      <tr key={`weight-${index}`} style={{ verticalAlign: 'middle' }}>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                        <td style={{ verticalAlign: 'middle', textAlign: 'center', pointerEvents: 'none' }}>
                          <label>重量</label>
                        </td>
                        <td style={{ verticalAlign: 'middle', width: '9.5%' }}>
                          <label>
                            {surfaceWorkType?.find((item) => item.value === i.processDetailWorkTypeGroup)?.label}
                          </label>
                        </td>
                        <td style={{ width: '9.5%' }}>
                          <label>{processDetailsType?.find((item) => item.id === i.processDetailTypeNo)?.name}</label>
                        </td>
                        <td>
                          {/* 2025-06-27 IQX_WEBEST-429 子部品の工程入力の表記を変更してほしい */}
                          <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                            {i.weightAutoExtract && i.weightAutoExtract > 0 ? toDecimal(i.weightAutoExtract, 2) : '-'}
                          </label>
                          <Input
                            className="input-editable"
                            value={i.weightUnitPrice ? toDecimal(i.weightUnitPrice, 2) : toDecimal(0, 2)}
                            onChange={(e) => changeDetails(e, i.no, 'weightUnitPrice')}
                            onBlur={(e) => blurDetails(e, i.no, 'weightUnitPrice')}
                            style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                            onKeyPress={(e) => handleKeyPress(e, false)}
                          />
                        </td>
                        <td>
                          {/* 2025-06-27 IQX_WEBEST-429 子部品の工程入力の表記を変更してほしい */}
                          <label style={{ marginLeft: 0, width: '35%', textAlign: 'center' }}>
                            {i.weightCountAutoExtract && i.weightCountAutoExtract > 0 ? i.weightCountAutoExtract : '-'}
                          </label>
                          <Input
                            className="input-editable"
                            value={i.weightCount}
                            onChange={(e) => changeDetails(e, i.no, 'weightCount')}
                            style={{ height: 32, textAlign: 'center', width: '58%', marginLeft: 9 }}
                            onKeyPress={(e) => handleKeyPress(e, false)}
                          />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <label style={{ marginRight: '5px' }}>{toDecimal(i.totalWeight, 2)}</label>
                        </td>
                      </tr>
                    )}
                  </>
                );
              })}
            </tbody>
          </Table>
        </Row>
      ) : (
        ''
      )}
    </>
  );
});

export default IQ3KouteiInput_Hyoumenshori;
